/* eslint-disable @atlaskit/design-system/ensure-design-token-usage */
// eslint-disable-next-line import/no-extraneous-dependencies, @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
import styled from '@emotion/styled';
import { token } from '@atlaskit/tokens';
// TODO quality ticket https://product-fabric.atlassian.net/browse/DSP-4321
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const HistoricalMarker = styled.span({
	position: 'absolute',
	bottom: 0,
	display: 'block',
	width: '100%',
	height: token('space.050', '4px'),
	backgroundColor: 'hsla(0, 0%, 100%, 0.5)',
});
